import { type Memberships } from './collections/memberships'
import { type Teams } from './collections/teams'
import { employeeMemberships } from './employeeMemberships'

export const employeeTeams = (teams: Teams, memberships: Memberships, employeeId: string) => {
  return employeeMemberships(memberships, employeeId)
    .map((membership) => teams.get(membership.attributes.team_id))
    .filter(Boolean)
}
